/* eslint-disable eag/match-named-export */

type PositionValue = 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky';

export const POSITION_CLASSES: Record<PositionValue, string> = {
  static: 'static',
  relative: 'relative',
  absolute: 'absolute',
  fixed: 'fixed',
  sticky: 'sticky',
};
